import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useLogo} from "../../util/logoUtils";
import styles from "./LoadingLogo.module.css";

const LoadingLogo = () => {
  const [dots, setDots] = useState(".");
  const logo = useLogo();
  const {t} = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => (prevDots.length < 3 ? `${prevDots}.` : "."));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.logoContainer}>
      <img
        src={logo}
        alt="Company Logo"
        className={styles.logoImg}
      />
      <div className={styles.spinnerWrapper}>
        <div className={styles.spinner} />
      </div>
      <p className={styles.loadingText}>
        {t("gameLoading")}
        {dots}
      </p>
    </div>
  );
};

export default LoadingLogo;
